import produce from 'immer';

import {
  FETCH_WATCH_HISTORY_SUCCEEDED,
  UPDATE_WATCH_HISTORY_SUCCEEDED,
  DELETE_WATCH_HISTORY_OPTIMISTIC,
  DELETE_ALL_WATCH_HISTORY_OPTIMISTIC,
  LOGOUT,
} from '../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_WATCH_HISTORY_SUCCEEDED: {
      return action.payload.entities.watchHistory;
    }

    case UPDATE_WATCH_HISTORY_SUCCEEDED: {
      draft[action.payload.dramaId] = action.payload;
      return;
    }

    case DELETE_WATCH_HISTORY_OPTIMISTIC: {
      delete draft[action.payload];
      return;
    }

    case DELETE_ALL_WATCH_HISTORY_OPTIMISTIC:
    case LOGOUT: {
      return initState;
    }
  }
}, initState);
